import styled from "styled-components";
import Variables from "../../assets/styleVariables";
import {
  CLOSED_SIDEBAR_WIDTH,
  EXPANDED_SIDEBAR_WIDTH,
  TABS_HEIGHT
} from "../../constants/fixedStyleVariables";

export const TabBarWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: ${props => (props.isInMiddleOfContent ? "center" : "flex-end")};
  direction: rtl;
  text-align: right;
  border-bottom: ${props =>
    props.isInMiddleOfContent
      ? ""
      : "1px solid " + Variables.colors.complementary_400};
  height: ${TABS_HEIGHT}px;
  background-color: ${Variables.colors.complementary};
  position: fixed;
  left: 8px;
  top: ${props => (props.topMargin ? props.topMargin + "px" : 0)};
  ${props => {
    if (props.expand) {
      return `width: calc(100% - ${EXPANDED_SIDEBAR_WIDTH}px);`;
    } else {
      return `width: calc(100% - ${CLOSED_SIDEBAR_WIDTH}px);`;
    }
  }};
  z-index: 9995;
  width: ${props => (props.isInMiddleOfContent ? "100%" : "")};

  .tab-title {
    font-size: ${Variables.font_sizes.x2_medium};
    font-weight: ${Variables.font_weight.medium};
    color: ${Variables.colors.complementary_600};
    margin-left: 24px;
    padding-right: 16px;
    width: 100%;
  }

  .tabs {
    display: flex;
    align-items: center;
    flex: 1;
  }
`;

export const TabWrapper = styled.div`
  max-width: 270px;
  width: ${props => (props.isInMiddleOfContent ? "200px" : "100%")};
  height: ${props => (props.isInMiddleOfContent ? "36px" : "46px")};
  position: relative;
  overflow: hidden;
  padding: ${props => (props.isInMiddleOfContent ? "0 12px" : "0 25px 0 8px")};
  display: flex;
  align-items: center;
  background-color: ${props =>
    props.isInMiddleOfContent ? Variables.colors.complementary_250 : ""};
  justify-content: ${props =>
    props.isInMiddleOfContent ? "center" : "flex-start"};
  cursor: pointer;

  ${props => {
    if (props.isInMiddleOfContent) {
      if (props.position === "first") {
        return `
        border-top-right-radius: 16px;
        border-bottom-right-radius: 16px;
        `;
      } else if (props.position === "end") {
        return `
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
        `;
      } else {
        return `
        border-right: 1px solid ${Variables.colors.complementary_450};
        border-left: 1px solid ${Variables.colors.complementary_450};
      `;
      }
    }
  }}
  ${props => {
    if (props.active) {
      if (props.isInMiddleOfContent) {
        return `
            background-color: ${Variables.colors.primary_500} !important;
            color:${Variables.colors.complementary}!important;
            &:hover{
                opacity: 0.8;
            }
        `;
      } else {
        return `
        i{
          &:before {
           color:${
             props.activeColor
               ? props.activeColor
               : Variables.colors.complementary_600
           };
         }
        }
        span {
         color:${
           props.activeColor
             ? props.activeColor
             : Variables.colors.complementary_800
         };
        }
        `;
      }
    } else {
      if (props.isInMiddleOfContent) {
        return `
        color:${Variables.colors.complementary_800}!important;
            &:hover{
                opacity: 0.8;
            }
        `;
      } else {
        return `
        i{
          &:before {
           color:${Variables.colors.complementary_600};
         }
        }
        span {
         color:${Variables.colors.complementary_800};
        }
        `;
      }
    }
  }}
  i {
    &:before {
      font-size: 20px;
      margin-left: 16px;
    }
  }

  &:before {
    position: absolute;
    bottom: -13px;
    right: 2.5%;
    width: 95%;
    ${props => {
      if (props.activeColor) {
        return `background-color: ${props.activeColor}`;
      }
    }};
    height: 16px;
    content: " ";
    border-radius: 64px;
  }
`;
export const TabContainer = styled.div`
  width: 100%;
  //height: calc(100vh - 65px);
`;
export const TabContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  //overflow-y: auto;
  .tab-content {
    display: none;
  }
`;
